import { oz } from '@weft/utils';
import { PaymentOverviewSchema } from './payment-overview-schema';

export const GetPaymentsOverviewsResponseSchema = oz.object({
  paymentsOverviews: oz.array(PaymentOverviewSchema),
  count: oz.number(),
}).openapi('GetPaymentsOverviewsResponse');

export type GetPaymentsOverviewsResponse = oz.TypeOf<typeof GetPaymentsOverviewsResponseSchema>;